import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { Log } from 'ng2-logger';
import { ModalComponent } from '@app/shared/components';
import { ToolReturnsService } from '@app/core/services/tool-returns.service';
import { ToolRequestsService } from '@app/core/services/tool-requests.service';
import { Tool } from '@app/tool/model/tool.model';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { ToolSet } from '@app/tool/model/toolSet.model';
import * as moment from 'moment';
import { TransportTypeEnum } from '@models/enums/transport-type.enum';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-transport-details-modal',
    templateUrl: './transport-details-model.component.html',
    styleUrls: ['./transport-details-model.component.scss']
})
export class TransportDetailsModelComponent implements OnInit {
    _logger = Log.create(TransportDetailsModelComponent.name);
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Output() loadToolRequest = new EventEmitter<any>();
    @Output() unloadToolRequest = new EventEmitter<any>();

    transport: any = {};
    isLoading: boolean;
    tools: Tool[];
    isConfirmationInProgress: boolean;
    reason: string;

    constructor(private returnService: ToolReturnsService,
                private requestService: ToolRequestsService,
                private translateService: TranslateService) {
    }

    ngOnInit() {
    }

    open(transportDetails: any) {
        this._logger.info('transport', transportDetails);
        this.isLoading = true;
        this.transport = transportDetails;
        this.reason = transportDetails.reason;
        if (this.transport.isRequest) {
            const tableConfig = new TableConfig();
            tableConfig.pager.pageSize = -1;
            tableConfig.upsertFilter("dontShowToolsAtLine", true);
            this.requestService.getToolRequestTools(transportDetails.id, tableConfig).subscribe(
                (data) => {
                    this._logger.info('getToolRequestTools:: API Returned data', data);

                    const toolsThatAreNotAtLine = []
                    data.items.forEach((tool: Tool | ToolSet) => {
                        if (tool instanceof Tool && !tool.isAlreadyReservedForLine) {
                            toolsThatAreNotAtLine.push(tool);
                        }
                        if (tool instanceof ToolSet) {
                            tool.tools = tool.tools.filter(toolFromSet => !toolFromSet.isAlreadyReservedForLine)
                            if (tool.tools.length !== 0) {
                                toolsThatAreNotAtLine.push(tool)
                            }
                        }
                    });
                    this.tools = toolsThatAreNotAtLine;
                    this.isLoading = false;
                },
                (error) => {
                    this._logger.error('getToolRequestTools:: API Returned error', error);
                    this.isLoading = false;
                }
            )
        } else {
            this.returnService.getToolReturn(transportDetails.id).subscribe(
                (data) => {
                    this._logger.info('getToolReturnTools:: API Returned data', data);
                    this.tools = data['returnTools'];
                    this.reason = data.reason;
                    this.isLoading = false;
                },
                (error) => {
                    this._logger.error('getToolReturnTools:: API Returned error', error);
                    this.isLoading = false;
                }
            )
        }
        this.modal.open();
    }

    onLoad() {
        this.close();
        this.loadToolRequest.emit(this.transport);
    }

    onUnload() {
        this.close();
        this.unloadToolRequest.emit(this.transport);
    }

    onCancel() {
        this.close();
    }

    close() {
        this.modal.close();
        this.isConfirmationInProgress = false;
    }

    get infoLabel() {
        return this.transport.transportType === TransportTypeEnum.LINE ?
            this.translateService.instant('milkrun.transportation-requests.transport-details.infoFromLine') :
            this.translateService.instant('milkrun.transportation-requests.transport-details.reason');
    }

    get createdDate(): any {
        return moment(this.transport.createdDate).format('DD/MM/YYYY - HH:mm');
    }

    transportLocation(transport) {
        return transport && transport.isRequest ? `${transport.location}` : `${transport.location} (${transport.plantName})`;
    }

    transportDestination(transport) {
        return transport && !transport.isRequest ? `${transport.destination} (${transport.plantName})` : `${transport.destination}`;
    }
}
